var _metadata, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeumi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    xmlSpace: "preserve",
    width: 105,
    height: 60,
    viewBox: "0 0 105 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path16"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -83.5827,457.236 H 426.197 V -36.8583 H -83.5827 Z",
    id: "path24"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    fx: 0,
    fy: 0,
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(259.42114,0,0,-259.42114,171.3071,210.1889)",
    spreadMethod: "pad",
    id: "radialGradient42"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    },
    offset: 0,
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    },
    offset: 0.14080625,
    id: "stop34"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    },
    offset: 0.235,
    id: "stop36"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    },
    offset: 0.69336928,
    id: "stop38"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    },
    offset: 1,
    id: "stop40"
  })), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "mask44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z",
    style: {
      fill: "url(#radialGradient42)",
      stroke: "none"
    },
    id: "path46"
  })))))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -83.5827,457.236 H 426.197 V -36.8583 H -83.5827 Z",
    id: "path56"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path94"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 335.235,57.4585 h 81.354 V -4.0159 h -81.354 z",
    id: "path102"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.821262,-11.812276,-11.812276,-15.821262,367.58524,42.896474)",
    spreadMethod: "pad",
    id: "linearGradient114"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#005baa"
    },
    offset: 0,
    id: "stop110"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#231f5c"
    },
    offset: 1,
    id: "stop112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.47457,-5.4408218,-5.4408218,-20.47457,365.04718,48.890216)",
    spreadMethod: "pad",
    id: "linearGradient124"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#005baa"
    },
    offset: 0,
    id: "stop120"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#231f5c"
    },
    offset: 1,
    id: "stop122"
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 336.962,10.751 h 78.217 v 43.346 h -78.217 z",
    id: "path126"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath230"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path228"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path252"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath274"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path272"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path328"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath350"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path348"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath418"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path416"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath440"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path438"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath480"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path478"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path510"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path614"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath640"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path638"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath852"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path850"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath892"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path890"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath940"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -34.5396,453.37 H 426.197 V -53.6347 H -34.5396 Z",
    id: "path938"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.007,4.377 H 425.197 V 426.29 H -1.007 Z",
    id: "path942"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath986"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 425.197 V 425.197 H 0 Z",
    id: "path984"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,60.00001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath26)",
    id: "g74",
    style: {
      opacity: 0.07000732
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g68"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath58)",
    id: "g66"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(-336.71563,-10.013286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g92",
    clipPath: "url(#clipPath96)",
    transform: "translate(0.11943579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g98"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g190"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath104)",
    id: "g188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 362.985,38.978 c 0.92,-6.403 6.428,-11.324 13.085,-11.324 v 0 c 6.658,0 12.165,4.92 13.086,11.323 v 0 l -0.001,0.001 z",
    style: {
      fill: "url(#linearGradient114)",
      stroke: "none"
    },
    id: "path130"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 362.848,40.875 7.951,0.002 c 0.306,-0.014 0.344,0.259 0.344,0.259 v 0 c 0.027,0.161 0.054,0.331 0.054,0.331 v 0 l 10e-4,-10e-4 c 0.305,2.437 2.382,4.322 4.902,4.322 v 0 c 2.528,0 4.612,-1.899 4.904,-4.348 v 0 c 0.009,-0.054 0.03,-0.181 0.051,-0.304 v 0 c 0,0 0.037,-0.273 0.343,-0.259 v 0 l 7.894,-0.002 c 0,7.303 -5.919,13.222 -13.222,13.222 v 0 c -7.301,0 -13.222,-5.919 -13.222,-13.222",
    style: {
      fill: "url(#linearGradient124)",
      stroke: "none"
    },
    id: "path140"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336.9618,22.3659)",
    id: "g152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -1.772 h 4.489 v -7.871 h 2.284 v 7.871 H 7.836 V 0 Z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g186"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath128)",
    id: "g184"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(349.5311,22.3662)",
    id: "g156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 2.627,0 3.072,-1.79 3.072,-4.244 V -9.643 H 0.77 v 5.299 c 0,1.436 -0.209,2.572 -1.545,2.572 H -3.499 V 0 Z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 364.689,18.704 h 2.229 v -7.952 h -2.229 z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 382.077,16.95 h -2.289 v 5.417 h 2.289 z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(387.8792,14.4956)",
    id: "g164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 1.936 v 3.572 c 0,1.545 -0.409,2.645 -2.045,2.645 h -0.679 l -1.641,-7.989 h -2.254 l 1.753,7.87 H -4.463 V 7.871 H 0.3 c 2.909,0 3.854,-1.545 3.835,-4.69 V -1.772 H 0 Z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 395.891,12.723 h -2.284 v 9.643 h 2.284 z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(404.0743,12.7233)",
    id: "g170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -3.499,5.453 C -4.139,5.236 -4.28,4.726 -4.28,3.763 V 0 h -2.237 v 3.217 c 0,1.527 0.537,2.927 2.254,3.227 l -2.199,3.199 h 2.345 l 3.108,-4.672 c 0.884,0.144 1.091,0.782 1.091,1.727 V 9.643 H 2.299 V 6.925 C 2.299,5.044 1.281,4.054 -0.227,3.817 L 2.417,0 Z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.1795,22.3662)",
    id: "g174"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -3.59,-9.643 h -2.405 l 3.05,7.871 h -4.58 v 3.744 h 2.181 V 0 Z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.0106,22.3662)",
    id: "g178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -3.468,-9.643 h -2.303 l 2.826,7.871 h -6.37 V 0 Z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360.6973,12.7233)",
    id: "g182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -3.499,5.453 C -4.139,5.236 -4.28,4.726 -4.28,3.763 V 0 h -2.237 v 3.217 c 0,1.527 0.537,2.927 2.254,3.227 l -2.199,3.199 h 2.345 l 3.108,-4.672 c 0.884,0.144 1.091,0.782 1.091,1.727 V 9.643 H 2.299 V 6.925 C 2.299,5.044 1.281,4.054 -0.227,3.817 L 2.417,0 Z",
    style: {
      fill: "#293271",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path180"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeumi);
export default __webpack_public_path__ + "static/media/Leumi.077a000c4991b4db5b3dc996cbcceecf.svg";
export { ForwardRef as ReactComponent };